import styled from 'styled-components';

export const SelectVesselPageContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 400px;
    gap: 20px;
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    font-size: 1rem;
    background: #eee;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 40px 45px 60px 45px;
`;

export const SelectVesselTextWrapper = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    font-size: 1rem;
    margin-bottom: 20px;
`;

export const SelectVesselWrapper = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
    font-size: 1rem;
`;

export const IncludeInactiveVesselsWrapper = styled.div`
    padding-top: 20px;
    display: block;
    input[type="checkbox"] {
       margin: 0 5px 0 0;
    }
`;
